import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Modal, Select, Tooltip, Input } from 'components';
import { CleanIcon, AddIcon, DeleteIcon, StarActiveIcon, StarIcon, DownloadIcon } from 'assets/icons';
import { Globals } from 'utils';
import { CalificationService } from 'services';
import moment from 'moment';

interface Props extends RouteComponentProps {
	dispatch: any;
}

const INITIAL_STATE = {
	level_id: '',
	since: '',
	until: '',
	search: '',
};

class Notifications extends React.Component<Props> {
	timer: any = undefined;
	state = {
		data: [] as any[],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de servicio', 
			'Usuario', 
			'Afiliado', 
			'Calificación', 
			'Comentario', 
			//'Acciones'
		],
		form: INITIAL_STATE,
		createVisible: false,
		viewVisible: false,
		currentItem: null as any,
	};

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Calificaciones',
				onBack: null,
			},
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: '',
			},
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await CalificationService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});

		this.setState({
			data: res.ratings?.rows || [],
			last_page: res.ratings?.count || 1,
		});
	};

	reset = () => {
		this.setState(
			{
				form: INITIAL_STATE,
				page: 1,
			},
			() => this.load(true),
		);
	};

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value,
			},
		});
	};

	changeDate = (field: string, value: any) => {
		const dateValue = value && value.target ? value.target.value : value;
		this.setState({
			form: {
				...this.state.form,
				[field]: dateValue,
			},
		});
	};

	applyFilters = () => {
		this.setState(
			{
				page: 1,
			},
			() => this.load(true),
		);
	};

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la calificación?', async () => {
			await CalificationService.admin.delete({
				id: item.id,
			});
			this.load(true);
		});
	};

	renderStars = (rating: number) => {
		const stars = [];
		for (let i = 1; i <= 5; i++) {
			if (i <= rating) {
				// Estrella activa (rellena)
				stars.push(
					<img 
						key={i} 
						src={StarActiveIcon} 
						alt="★" 
						style={{ width: '20px', height: '20px', marginRight: '2px' }}
					/>
				);
			} else {
				// Estrella inactiva (vacía) - usando StarArchiveIcon
				stars.push(
					<img 
						key={i} 
						src={ StarIcon} 
						alt="☆" 
						style={{ width: '20px', height: '20px', marginRight: '2px' }}
					/>
				);
			}
		}
		return <div style={{ display: 'flex', alignItems: 'center' }}>{stars}</div>;
	};

	print = async () => {
		const res: any = await CalificationService.admin.get({
			page: this.state.page,
			...this.state.form,
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	render() {
		const { createVisible, viewVisible } = this.state;

		return (
			<div id="admin-notifications">

				{/* Filtros */}
				<div className="row row-filter">
					<div className="col-md-3">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre o CI/RIF"
							placeholder="Buscar"
							className="input-table"
							onChange={(e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								}, 1000);
								this.change(e);
							}}
						/>
					</div>
					<div className="col-md-3">
						<DatePicker
							label="Desde"
							name="since"
							value={this.state.form.since}
							onChange={(value: any) => this.changeDate('since', value)}
						/>
					</div>
					<div className="col-md-3">
						<DatePicker
							label="Hasta"
							name="until"
							value={this.state.form.until}
							onChange={(value: any) => this.changeDate('until', value)}
						/>
					</div>
					<div className="col-md-3 filter-actions">
						<Button className="btn-filter" onClick={this.applyFilters}>
							Filtrar
						</Button>

						{this.state.form !== INITIAL_STATE && (
							<button className="btn btn-clean" onClick={this.reset}>
								<img src={CleanIcon} alt="Limpiar filtros" />
							</button>
						)}
					</div>
				</div>

				{/* Tabla */}
				<Table
					title="Calificaciones"
					data={this.state.data.length}
					rightAlign={[6]}
					header={this.state.header}
					titleRight={
						<Button className="btn-download" onClick={() => this.print()}>
							<img src={DownloadIcon} alt="Descargar Excel" />
							<span>Descargar Excel</span>
						</Button>
					}
				>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{i.date_es}</td>
								<td>{i.client ? i.client?.name+' '+i.client?.document_format : ''}</td>
								<td>{i.affiliate ? i.affiliate?.name+' '+i.affiliate?.document_format : ''}</td>
								<td>{this.renderStars(i.rating)}</td>
								<td>{i.comments}</td>
								{/* <td className="text-right">
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
											<img src={DeleteIcon} alt="Eliminar" />
										</a>
									</Tooltip>
								</td> */}
							</tr>
						);
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page,
						});
						this.load();
					}}
				/>
			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {};
})(Notifications);